/*
 * Copyright (c) 2022 Puratos. All rights reserved.
 */

import * as React from 'react';
import {connect} from "react-redux";
import {addBundleToCartAction, isLoadingById} from "../../../selectors/loader";
import ProductRow from "./ProductRow";
import {ShowHide} from "../../atoms/layout/ShowHide";
import {Divider} from "../../atoms/layout/Divider";
import ModalBundleRow from "./ModalBundleRow";
import {selectBundleForMaterial} from "../../../selectors/my-puratos/promotions";

class ModalProductRow extends React.Component {

    render() {
        const {
            sku,
            bundles,
            bundleLoading,
            skuChangeHandler,
            addAll,
            showBundles,
            selected,
            onQuantityChange,
            hideCartAmountAlert,
            quantity,
            addEvent,
            position,
            productCategoryTag
        } = this.props;

        const hasBundles = showBundles && bundles?.length > 0;

        return <React.Fragment>
            <ProductRow productCategoryTag={productCategoryTag} key={sku[0]?.materialNumber} product={sku} skuChangeHandler={skuChangeHandler} position={position}
                        onQuantityChange={onQuantityChange} addAll={addAll} selected={selected || sku[0]?.materialNumber}
                        hideCartAmountAlert={hideCartAmountAlert} quantity={quantity} addEvent={addEvent} showStock/>

            {hasBundles && <Divider/>}

            <ShowHide show={hasBundles}>
                {bundles?.map((bundle, index) =>
                    <ModalBundleRow key={bundle?.bundleId} promotion={bundle} bundle={bundle?.option} position={position}
                                    isBundleLoading={bundleLoading[index]} addEvent={addEvent}/>)}

            </ShowHide>
        </React.Fragment>;
    }
}

const mapStateToProps = (state, ownProps) => {
    const bundles = ownProps.sku.map(sku => selectBundleForMaterial(state, sku.materialNumber)).filter(Boolean).flat();

    return {
        bundles,
        bundleLoading: bundles?.map(bundle => isLoadingById(state, addBundleToCartAction(bundle?.bundleId)))
    };
};

export default connect(mapStateToProps)(ModalProductRow);
